import CandidateExpertiseItem, { CandidateExpertiseItemType } from '../CandidateExpertiseItem';

const CandidateExpertise = (props: CandidateExpertiseItemType): JSX.Element => {
  return <CandidateExpertiseItem {...props} />;
};

export default CandidateExpertise;
